import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { history } from '../redux_store/history/history';

export { PrivateRoutes };

function PrivateRoutes() {
  const auth = useSelector((x: any) => x?.auth?.value);
  const auth1 = useSelector((x: any) => x);

  if (!auth) {
    return <Navigate to="/login" state={{ from: history?.location }} />;
  }

  // authorized so return outlet for child routes
  return <Outlet />;
}
